
import { Form } from 'element-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { changeStayRoomStatus } from '@/api/stayRoomClose';

@Component({
  name: 'roomReserveConfig',
  components: {
  },
})

export default class extends Vue {
  @Prop({ required: true }) private roomList!: any;

  private form: any = {
    dateRange: [],
    startDate: '',
    endDate: '',
    roomIdxList: [],
    closeStatus: true,
  }

  private rules = {
    dateRange: [
      {
        type: 'array',
        required: true,
        message: '기간을 입력해주세요.',
        trigger: ['blur', 'change'],
      },
    ],
    roomIdxList: [
      {
        type: 'array',
        required: true,
        message: '최소 1개 객실을 선택해주세요.',
        trigger: ['blur', 'change'],
      },
    ],
  }

  private loading = false;

  private checkAll = false;

  private submitForm() {
    (this.$refs.form as Form).validate((valid:boolean) => {
      if (valid) {
        this.$confirm('해당 설정을 저장하시겠습니까?', '설정 저장', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning',
        }).then(() => {
          this.loading = true;
          changeStayRoomStatus(this.form).then(() => {
            this.$message.success('객실 상태를 수정했습니다.');
            this.$emit('success');
          });
        });
      }
    });
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.form.dateRange && this.form.dateRange.length === 2) {
      this.form.startDate = this.form.dateRange[0];
      this.form.endDate = this.form.dateRange[1];
    } else {
      this.form.startDate = '';
      this.form.endDate = '';
    }
  }

  private handleChangeCheckAll(val: boolean) {
    if (val) this.form.roomIdxList = this.roomList.map((r: any) => r.idx);
    else this.form.roomIdxList = [];
  }

  private handleCheckedChange() {
    if (this.roomList.length === this.form.roomIdxList.length) this.checkAll = true;
    else this.checkAll = false;
  }
}
